import { RESET_WIZARD } from 'containers/AwarenessCenter/WizardCampaign/steps/constants'

import { GET_DEFAULT_TRAINING_DATA_ASYNC } from '../../WizardTrainingCampaign/constants'

import { DATA_HAS_CHANGED, GET_EMAIL_PREVIEW_ASYNC } from './constants'

export default function () {
  const initialState = {
    error: null,
    loader: false,
    previewLoader: false,
    emailPreview: null,
    dataHasChanged: false,
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case GET_DEFAULT_TRAINING_DATA_ASYNC.INITIATE:
        return {
          ...state,
          error: null,
          loader: true,
        }
      case GET_DEFAULT_TRAINING_DATA_ASYNC.SUCCESS:
        return {
          ...state,
          error: null,
          loader: false,
        }
      case GET_DEFAULT_TRAINING_DATA_ASYNC.ERROR:
        return {
          ...state,
          error: action.payload.error,
          loader: false,
        }
      case GET_EMAIL_PREVIEW_ASYNC.INITIATE:
        return {
          ...state,
          error: null,
          previewLoader: true,
          emailPreview: null,
        }
      case GET_EMAIL_PREVIEW_ASYNC.SUCCESS:
        return {
          ...state,
          previewLoader: false,
          error: null,
          emailPreview: action.payload.data.response.body,
        }
      case GET_EMAIL_PREVIEW_ASYNC.ERROR:
        return {
          ...state,
          previewLoader: false,
          error: action.payload.error,
        }
      case DATA_HAS_CHANGED:
        return {
          ...state,
          dataHasChanged: true,
        }
      case RESET_WIZARD: {
        return {
          ...initialState,
        }
      }
      default:
        return state
    }
  }
}
